const KEYBOARD_KEYS = new Set([
  'Tab',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
]);

const initFocusMode = () => {
  const root = document.documentElement;

  const setMode = (mode) => {
    if (root.dataset.focusMode === mode) return;
    root.dataset.focusMode = mode;
  };

  setMode('pointer');

  window.addEventListener(
    'keydown',
    (event) => {
      if (KEYBOARD_KEYS.has(event.key)) setMode('keyboard');
    },
    true,
  );

  window.addEventListener(
    'pointerdown',
    (event) => {
      if (
        event.pointerType === 'mouse' ||
        event.pointerType === 'touch' ||
        event.pointerType === 'pen'
      ) {
        setMode('pointer');
      }
    },
    true,
  );
};

export default initFocusMode;
